import { Typography } from 'antd';
import { useTheme } from 'context/ThemeProvider/ThemeProvider';

const getLogo = (navCollapsed) => {
  if (navCollapsed) {
    return 'K';
  }
  return 'Koras';
};

export const Logo = () => {
  const { isNavCollapsed } = useTheme();
  return (
    <Typography.Title style={{ paddingLeft: 16, marginTop: 16, marginBottom: 16 }} level={3}>
      {getLogo(isNavCollapsed)}
    </Typography.Title>
  );
};

export default Logo;
